/* Accessible tabs. [data-tabs] contains [role=tab] buttons (aria-controls) and [role=tabpanel] panels.
   Add data-tabs-hash to keep the active tab in the URL hash (information page). */
(function () {
  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var useHash = root.hasAttribute('data-tabs-hash');

    function panelFor(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }

    function select(tab, focus, silent) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var p = panelFor(t);
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      if (useHash && !silent && tab.getAttribute('data-hash')) {
        history.replaceState(null, '', '#' + tab.getAttribute('data-hash'));
      }
      root.dispatchEvent(new CustomEvent('tabs:change', { detail: { tab: tab } }));
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) {
        if (tab.tagName === 'A') e.preventDefault();
        select(tab, false);
        if (useHash) window.scrollTo({ top: 0 });
      });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });

    function fromHash() {
      var h = window.location.hash.replace('#', '');
      var match = tabs.filter(function (t) { return t.getAttribute('data-hash') === h; })[0];
      if (!match) {
        // After a form post the hash is lost: open the panel that holds the success message.
        var ok = root.querySelector('[data-form-success]');
        var panel = ok && ok.closest('[role="tabpanel"]');
        if (panel) match = tabs.filter(function (t) { return t.getAttribute('aria-controls') === panel.id; })[0];
      }
      select(match || tabs[0], false, true);
    }
    if (useHash) {
      fromHash();
      window.addEventListener('hashchange', fromHash);
    }
  }
  document.querySelectorAll('[data-tabs]').forEach(init);

  /* Phones: product tabs become accordions (headers inside each panel). */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-acc]');
    if (!head) return;
    var panel = head.closest('.tpanel');
    if (!panel) return;
    var open = !panel.classList.contains('acc-open');
    panel.classList.toggle('acc-open', open);
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
